<template>
  <div>
    <client-only>
      <el-dialog
        class="try-on-dialog"
        width="852px"
        :showClose="false"
        :modelValue="show"
        :beforeClose="handleClose"
        @close="SDTryONPageLeave"
      >
        <i class="iconfont icon-close-s wrap-close" @click="toClose"></i>
        <div v-loading="boxLoading || uploading" class="try-wrap-box">
          <div class="trybox-left">
            <!-- 试戴展示 -->
            <div v-if="!isShowModal" class="glasses-container">
              <div id="imgCon" ref="imgCon">
                <NuxtImgWrap
                  ref="bgImg"
                  :src="bgImg"
                  class="bgImg"
                  alt="vooglam glasses"
                  @load="isBgImgeLoad = true"
                />
                <div id="glasses" ref="glasses" @mousedown="drag">
                  <div class="shade"></div>
                  <NuxtImgWrap
                    id="glassesImg"
                    ref="glassesImg"
                    alt="vooglam glasses"
                    :src="glassesData"
                    :style="`width:${oWidth}px;transform:rotate(${oRotate}deg);`"
                    @load="init"
                  />
                </div>
              </div>
              <!-- 先注释（js保留，样式已经删除） -->
              <!-- <div class="btn-list">
                            <ul class="left">
                                <li class="magnify" @click="magnify"><i class="iconfont icon-operation_add"></i></li>
                                <li class="shrink" @click="shrink"><i class="iconfont icon-operation_sub"></i></li>
                                <li class="rotateL" @click="rotateL"><i class="iconfont icon-rotate_left"></i></li>
                                <li class="rotateR" @click="rotateR"><i class="iconfont icon-rotate_right"></i></li>
                            </ul>
                            <ul class="right">
                                <li class="up" @click="up"><i class="iconfont icon-arrow_top"></i></li>
                                <li class="left" @click="left"><i class="iconfont icon-arrow_top"></i></li>
                                <li class="right" @click="right"><i class="iconfont icon-arrow_top"></i></li>
                                <li class="down" @click="down"><i class="iconfont icon-arrow_top"></i></li>
                            </ul>
                        </div> -->
              <div class="swiper-box" :class="[modelList.length <= 6 && 'spec']">
                <swiper
                  ref="imgProd"
                  class="pro-imgs"
                  :options="swiperOption"
                  :modules="swiperOption.modules"
                  :slidesPerView="swiperOption.slidesPerView"
                  :spaceBetween="swiperOption.spaceBetween"
                  :navigation="swiperOption.navigation"
                  @swiper="swiperInit"
                >
                  <swiper-slide
                    v-for="item in modelList"
                    :key="item.bImg"
                    :class="[{ 'show-border': checkObjSame(item.data) }]"
                    class="img-item"
                    @click="changeBg(item)"
                  >
                    <!-- icon-close-s -->
                    <i v-if="item.user" class="iconfont icon-guanbi2" @click.stop="del(item)"></i>
                    <!-- <NuxtImgWrap :src="item.bImg" alt="vooglam glasses" @load="init" /> -->
                    <NuxtImgWrap
                      :src="$util.akamai(item.bImg)"
                      alt="vooglam glasses"
                      @load="init"
                    />
                  </swiper-slide>
                </swiper>
                <div v-show="modelList.length > 6" class="button-prev">
                  <i class="icon-fanhui iconfont"></i>
                </div>
                <div v-show="modelList.length > 6" class="button-next">
                  <i class="icon-fanhui-right iconfont"></i>
                </div>
              </div>
            </div>
            <!-- 图片裁剪 -->
            <div v-else class="cropper-box">
              <VuePictureCropper
                :boxStyle="{
                  width: '388px',
                  height: '388px',
                  backgroundColor: '#f8f8f8',
                  margin: 'auto',
                }"
                :img="pic"
                :options="{
                  viewMode: 1,
                  dragMode: 'crop',
                  aspectRatio: 1,
                }"
                @ready="ready"
              />
              <div class="reupload" @click="reSelect">
                <p>
                  <i class="iconfont icon-xuanzhuan"></i>
                  Change image
                </p>
              </div>
            </div>
          </div>
          <div class="trybox-right">
            <!-- 上传图片按钮div -->
            <div v-show="!showCropperBtn" class="upload-session">
              <div class="try-online">
                <p>Try It On Virtually</p>
                <div>
                  Please upload a clear, centered photo without eyewear. This will help you find the
                  perfect style, but won't measure your size.
                </div>
              </div>
              <el-upload
                ref="upload"
                class="upload pop-tryon-upload"
                name="upload_img"
                accept=".jpg,.jpeg,.png"
                action="#"
                :limit="1"
                :multiple="false"
                :showFileList="false"
                :onProgress="progress"
                :onError="error"
                :beforeUpload="beforeUpload"
                :disabled="uploading"
              >
                <el-button
                  type="primary"
                  class="upload"
                  @click="SDTryONPageBtnClick('Upload Photo')"
                >
                  <p>
                    <!-- <i v-show="!uploading" class="iconfont icon-shangchuan"></i> -->
                    Upload Your Image
                  </p>
                </el-button>
              </el-upload>
            </div>
            <!-- 图片上传完成，确定裁剪的按钮div -->
            <div v-show="showCropperBtn" class="cropper-session">
              <div class="try-online">
                <div>Adjust the crop to keep your face centered and level</div>
                <div class="btn-list">
                  <el-button type="primary" class="cancel-btn" @click="cropperCancel"
                    >Cancel</el-button
                  >
                  <el-button type="primary" class="continue-btn" @click="getResult"
                    >Continue</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog v-model="tipShow" :showClose="false" :closeOnClickModal="false" width="600">
        <div class="close-tip">
          <div class="title">You are not logged in</div>
          <p>
            You can continue to use Photo Try-On.
            <br />
            But if you don't log in, next time you may need
            <br />
            to re-upload your photo for Photo Try-On.
          </p>
          <div class="btn-box">
            <el-button type="primary" @click="LRShow = true">Login now</el-button>
            <el-button type="default" class="second" @click="confirmClose">Continue</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 登录注册 -->
      <LoginRegister v-model:show="LRShow" :channel="112" @success="LRCallBack" />
    </client-only>
  </div>
</template>

<script>
import { imgCompression, randomString } from '@/assets/js/utils';
import { useStore } from '@/store';
import { mapActions, mapState } from 'pinia';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { defineAsyncComponent } from 'vue';
import VuePictureCropper, { cropper } from 'vue-picture-cropper';

export default {
  components: {
    LoginRegister: defineAsyncComponent(() => import('@/components/auth/login-register.vue')),
    VuePictureCropper,
    Swiper,
    SwiperSlide,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    glassesData: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    inErrorPage: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:show'],
  data() {
    return {
      // 登录注册弹框
      LRShow: false,
      // 关闭提示弹框
      tipShow: false,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        modules: [Navigation],
      },
      position: {
        x: 0,
        y: 0,
      },
      dLeft: '',
      dTop: '',
      moveX: '',
      moveY: '',
      pLeft: '',
      pTop: '',
      originData: {},
      oWidth: 0,
      oRotate: 0,
      rate: 0,
      bgImg: '',
      uploading: false,
      swiper: null,
      isShowModal: false, // 是否显示裁剪框(列表页试戴用this.$refs改变此值)
      pic: '', // 图片的base64(列表页试戴用this.$refs改变此值)
      // 裁剪结果
      result: {
        dataURL: '',
        blobURL: '',
      },
      showCropperBtn: false, // 是否显示裁剪按钮
      boxLoading: false, // 整个弹框loading效果
      isBgImgeLoad: false, // 试戴图片是否渲染完毕（每次给试戴大图赋值时改为false）
      tryon_trace_id: '',
      sdParams: {
        start_time: Date.now(),
      },
    };
  },
  computed: {
    ...mapState(useStore, ['modelList', 'userInfo', 'token']),
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.isBgImgeLoad = false;
        this.originData = this.modelList && this.modelList[0] && this.modelList[0].data;
        this.bgImg = this.modelList && this.modelList[0] && this.modelList[0].bImg;
        this.$nextTick(() => {
          this.init();
        });
        setTimeout(() => {
          this.swiper?.slideTo(0, 300, false);
        }, 300);
        if (newValue) {
          this.tryon_trace_id = `tryon_${randomString()}`;
          this.SDTryONPageView();
          window.addEventListener('beforeunload', this.SDTryONPageLeave);
        } else {
          window.removeEventListener('beforeunload', this.SDTryONPageLeave);
        }
      }
    },
    isBgImgeLoad(newValue) {
      if (newValue) {
        this.boxLoading = false;
      }
    },
  },
  mounted() {
    this.isBgImgeLoad = false;
    this.originData = this.modelList && this.modelList[0] && this.modelList[0].data;
    this.bgImg = this.modelList && this.modelList[0] && this.modelList[0].bImg;
  },
  unmounted() {
    window.removeEventListener('beforeunload', this.SDTryONPageLeave);
  },
  methods: {
    swiperInit(swiper) {
      this.swiper = swiper;
    },
    init() {
      if (this.$refs.imgCon && this.originData?.photo_original_width) {
        this.rate = this.$refs.imgCon.offsetWidth / this.originData.photo_original_width;
        this.oWidth =
          (this.originData.landmark72_12_x - this.originData.landmark72_0_x) * this.rate;
        const glassesImgRef = this.$refs.glassesImg;
        setTimeout(() => {
          if (this.$refs.glasses && this.$refs.glasses.style) {
            this.$refs.glasses.style.left = `${this.originData.landmark72_0_x * this.rate}px`;
            this.$refs.glasses.style.top = `${
              this.originData.landmark72_21_y * this.rate - glassesImgRef.offsetHeight * 0.382
            }px`;
          }
          this.oRotate = 0;
        }, 400);
      }
    },
    magnify() {
      if (
        this.oWidth <
        (this.originData.landmark72_12_x - this.originData.landmark72_0_x) * this.rate * 1.5
      ) {
        this.oWidth = this.$refs.glasses.offsetWidth + 10;
        if (parseFloat(this.$refs.glasses.style.left) >= 5) {
          this.$refs.glasses.style.left = `${parseFloat(this.$refs.glasses.style.left) - 5}px`;
        } else {
          this.$refs.glasses.style.left = '0px';
        }
      }
    },
    shrink() {
      if (
        this.oWidth >
        (this.originData.landmark72_12_x - this.originData.landmark72_0_x) * this.rate * 0.5
      ) {
        this.oWidth = this.$refs.glasses.offsetWidth - 10;
        this.$refs.glasses.style.left = `${parseFloat(this.$refs.glasses.style.left) + 5}px`;
      }
    },
    rotateL() {
      this.oRotate -= 10;
    },
    rotateR() {
      this.oRotate += 10;
    },
    left() {
      if (parseFloat(this.$refs.glasses.style.left) >= 10) {
        this.$refs.glasses.style.left = `${parseFloat(this.$refs.glasses.style.left) - 10}px`;
      } else {
        this.$refs.glasses.style.left = '0px';
      }
    },
    right() {
      if (
        parseFloat(this.$refs.glasses.style.left) < parseInt(400 - this.$refs.glasses.offsetWidth)
      ) {
        this.$refs.glasses.style.left = `${parseFloat(this.$refs.glasses.style.left) + 10}px`;
      } else {
        this.$refs.glasses.style.left = `${parseInt(410 - this.$refs.glasses.offsetWidth)}px`;
      }
    },
    up() {
      if (parseFloat(this.$refs.glasses.style.top) >= 10) {
        this.$refs.glasses.style.top = `${parseFloat(this.$refs.glasses.style.top) - 10}px`;
      } else {
        this.$refs.glasses.style.top = '0px';
      }
    },
    down() {
      if (
        parseFloat(this.$refs.glasses.style.top) < parseInt(400 - this.$refs.glasses.offsetHeight)
      ) {
        this.$refs.glasses.style.top = `${parseFloat(this.$refs.glasses.style.top) + 10}px`;
      } else {
        this.$refs.glasses.style.top = `${parseInt(410 - this.$refs.glasses.offsetHeight)}px`;
      }
    },
    drag() {
      this.$refs.glasses.style.transition = 'none';
      // eslint-disable-next-line no-caller
      const e = window.event || arguments.callee.caller.arguments[0];
      e.stopPropagation();
      this.position.x = e.clientX;
      this.position.y = e.clientY;
      this.dLeft = this.$refs.glasses.offsetLeft;
      this.dTop = this.$refs.glasses.offsetTop;
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      function move() {
        // eslint-disable-next-line no-caller
        const evt = window.event || arguments.callee.caller.arguments[0];
        evt.stopPropagation();
        that.moveX = evt.clientX - that.position.x;
        that.moveY = evt.clientY - that.position.y;
        that.pLeft = `${parseInt(that.dLeft) + that.moveX}px`;
        that.pTop = `${parseInt(that.dTop) + that.moveY}px`;
        that.$refs.glasses.style.left = that.pLeft;
        that.$refs.glasses.style.top = that.pTop;
        if (parseInt(that.pLeft) <= 0) that.$refs.glasses.style.left = '0px';
        if (parseInt(that.pLeft) >= parseInt(410 - that.$refs.glasses.offsetWidth)) {
          that.$refs.glasses.style.left = `${410 - that.$refs.glasses.offsetWidth}px`;
        }
        if (parseInt(that.pTop) <= 0) that.$refs.glasses.style.top = '0px';
        if (parseInt(that.pTop) >= parseInt(410 - that.$refs.glasses.offsetHeight)) {
          that.$refs.glasses.style.top = `${410 - that.$refs.glasses.offsetHeight}px`;
        }
      }
      function cancel() {
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', cancel);
        that.$refs.glasses.style.transition = 'all .3s';
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', cancel, false);
    },
    changeBg(item) {
      this.isBgImgeLoad = false;
      this.bgImg = item.bImg;
      this.originData = item.data;
      this.init();
    },
    progress() {
      this.uploading = true;
    },
    error(error) {
      console.log(error);
      this.uploading = false;
    },
    del(item) {
      // eslint-disable-next-line no-undef
      ElMessageBox.confirm(
        'It will be permanently removed and next time you will need to re-upload your photo for custom try-on.',
        'Delete uploaded photo?',
        {
          cancelButtonText: 'Later',
          confirmButtonText: 'Delete',
          type: 'warning',
          confirmButtonClass: 'tryon-confirm-button',
          cancelButtonClass: 'tryon-cancel-button',
        },
      )
        .then(() => {
          if (item.id) {
            this.$api.tryon.delImg({
              id: item.id,
              site_id: 2,
              type: 2,
              customer_id: this.userInfo.id,
              customer_email: this.userInfo.email,
            });
          }
          this.DEL_MODELLIST(item);
          if (!this.bgImg || item.bImg === this.bgImg) {
            // 当前bgImg已被删除，则重置模特为列表第一张
            this.isBgImgeLoad = false;
            this.bgImg = this.modelList[0].bImg;
            this.originData = this.modelList[0].data;
          }
          this.init();
        })
        .catch(() => {});
    },
    async beforeUpload(file) {
      const fileType = file.type?.toLowerCase();
      const isJPGorJPEGorPNG = ['image/jpeg', 'image/jpg', 'image/png'].includes(fileType);
      if (file.size > 1024 * 1024 * 10) {
        this.$message.warning('Sorry, images over 10MB are not supported.');
        return false;
      }
      if (!isJPGorJPEGorPNG) {
        this.$message.warning('The image format is not supported, please replace the image');
        return false; // 阻止上传
      }
      try {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          imgCompression(e.target.result, 500, (url) => {
            this.uploading = true;
            this.$forceUpdate();
            // 不走接口上传
            this.pic = url;
            // 显示裁剪框
            this.isShowModal = true;
            this.isBgImgeLoad = false;
            this.showCropperBtn = true;
            this.uploading = false;
          });
        };
      } catch (error) {
        console.log(error);
      }
      // 取消默认上传行为
      return false;
    },
    // 用已选择项信息与展示模特信息作比较，相同则加上选中效果
    checkObjSame(data) {
      const key1 = Object.keys(data);
      const key2 = Object.keys(this.originData);
      if (key1.length !== key2.length) {
        return false;
      }
      for (const key of key1) {
        if (data[key] !== this.originData[key]) {
          return false;
        }
      }
      return true;
    },
    // 获取base64格式
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        let imgResult = '';
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    // 获取base64 裁切使用
    async getResult() {
      this.boxLoading = true;
      if (!cropper) return;
      const base64 = cropper.getDataURL();
      // const blob: Blob | null = await cropper.getBlob()
      let blob = null;
      try {
        blob = await cropper.getBlob();
      } catch (error) {
        // 处理可能的错误
        console.error('Error getting blob:', error);
      }
      if (!blob) return;
      await cropper.getFile({
        fileName: 'test',
      });
      this.result.dataURL = base64;
      this.result.blobURL = URL.createObjectURL(blob);
      this.uploadImg(base64);
    },
    // 取消裁剪
    cropperCancel() {
      // 取消时发送事件
      this.isBgImgeLoad = false;
      this.bgImg = this.modelList[0].bImg;
      this.originData = this.modelList[0].data;
      this.swiper?.slideTo(0, 1000, false);
      this.$forceUpdate();
      // 关闭选择框
      this.isShowModal = false;
      this.showCropperBtn = false;
      // 如果是列表页引用的弹框,直接关闭
      if (['goodsList'].includes(this.type)) {
        this.close();
      }
    },
    // 裁剪后上传
    uploadImg(file) {
      const sendData = {
        img_base64: file,
        site_id: 2,
      };
      if (this.userInfo.id && this.userInfo.email) {
        sendData.customer_id = this.userInfo.id;
        sendData.customer_email = this.userInfo.email;
      }
      this.$api.common
        .uploadTryOnImg(sendData)
        .then((res) => {
          this.originData = res.data?.data || {};
          this.SET_MODELLIST({
            sImg: res.data.data.img_web_url,
            bImg: res.data.data.img_web_url,
            data: res.data.data,
            user: true,
            id: res.data.data.id,
          });
          this.isBgImgeLoad = false;
          this.bgImg = res.data.data.img_web_url;
          this.swiper?.slideTo(0, 1000, false);
          this.init();
        })
        .finally(() => {
          this.isShowModal = false;
          this.showCropperBtn = false;
          this.uploading = false;
          // 列表页引用的试戴裁剪完关闭
          if (['goodsList'].includes(this.type)) {
            // 成功时发送事件
            this.close();
          }
          // 监听isBgImgeLoad中关闭，防止图片没有渲染完毕loading就取消的情况
          // this.boxLoading = false
        });
    },
    // 重新选择
    reSelect() {
      const testup = document
        .querySelector('.pop-tryon-upload')
        ?.querySelector('.el-upload__input');
      testup?.click();
    },
    LRCallBack() {
      this.tipShow = false;
      this.close();
    },
    toClose() {
      // 图片上传中，禁止关闭
      if (this.boxLoading || this.uploading) {
        return false;
      }
      if (this.inErrorPage) {
        this.close();
        return;
      }
      // 当还没有进入裁剪时，点关闭直接关闭，原逻辑
      if (!this.isShowModal) {
        const firstModel = this.modelList[0];
        if (firstModel && firstModel.user && !firstModel.id) {
          this.tipShow = true;
          return;
        }
        this.close();
      } else {
        // 进入裁剪后，点击关闭，返回到上传图片的界面
        this.cropperCancel();
      }
    },
    confirmClose() {
      this.tipShow = false;
      this.close();
    },
    close() {
      // 取消时发送事件
      this.$emit('update:show', false);
    },
    // 点击弹框外部遮罩层，走右上角关闭按钮逻辑
    handleClose() {
      this.toClose();
    },
    /**
     * @description: 判断是否登录，未登录需要打开登录弹框
     * @return {*}
     */
    // importDoc () {
    //     if (!this.token) {
    //         this.LRShow = true
    //         setTimeout(() => {
    //             this.close()
    //         }, 100)
    //     }
    // },
    ready() {
      console.log('Cropper is ready.');
    },
    ...mapActions(useStore, ['SET_MODELLIST', 'DEL_MODELLIST', 'getUserModel']),
    /**
     * @TrackType sensorsdata
     * @EventType TryONPage_View
     * @EventDesc 试戴页面浏览
     * @EventParams {
     *  tryon_trace_id: 试戴轨迹id,
     *  try_type: 试戴类型,
     *  refer_page_name: 前向页面名称,
     *  refer_url_path: 前向页面路径,
     * }
     * @Tapd 1009440
     */
    SDTryONPageView() {
      this.sdParams.start_time = Date.now();
      try {
        const sdEventName = 'TryONPage_View';
        const sdEventParams = {
          tryon_trace_id: this.tryon_trace_id,
          try_type: 'Try on with pictures',
          refer_page_name: this.$route.meta.cnName || this.$route.name,
          refer_url_path: window.location.href,
          business_sku: this.product.business_sku,
          shop_sku: this.product.shop_sku,
          product_sku: this.product.sku,
          product_id: `${this.product.id}`,
          product_name: this.product.short_name,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * @TrackType sensorsdata
     * @EventType TryONPage_Leave
     * @EventDesc 试戴页面离开
     * @EventParams {
     *  tryon_trace_id: 试戴轨迹id,
     *  view_duration: 浏览时长,
     * }
     * @Tapd 1009440
     */
    SDTryONPageLeave() {
      try {
        const sdEventName = 'TryONPage_Leave';
        const currTime = Date.now();
        const sdEventParams = {
          tryon_trace_id: this.tryon_trace_id,
          view_duration: Math.ceil((currTime - this.sdParams.start_time) / 1000),
          try_type: 'Try on with pictures',
          business_sku: this.product.business_sku,
          shop_sku: this.product.shop_sku,
          product_sku: this.product.sku,
          product_id: `${this.product.id}`,
          product_name: this.product.short_name,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * @TrackType sensorsdata
     * @EventType TryONPageBtn_Click
     * @EventDesc 试戴页面按钮点击
     * @EventParams {
     *  tryon_trace_id: 试戴轨迹id,
     *  try_type: 试戴类型,
     *  btn_name: 按钮名称,
     * }
     * @Tapd 1009440
     */
    SDTryONPageBtnClick(btn_name) {
      try {
        const sdEventName = 'TryONPageBtn_Click';
        const sdEventParams = {
          tryon_trace_id: this.tryon_trace_id,
          try_type: 'Try on with pictures',
          btn_name,
          business_sku: this.product.business_sku,
          shop_sku: this.product.shop_sku,
          product_sku: this.product.sku,
          product_id: `${this.product.id}`,
          product_name: this.product.short_name,
        };
        window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss">
.try-on-dialog {
  overflow: hidden;

  // 对小屏做一个简单兼容
  max-width: 100%;
  color: red;
  .try-wrap-box {
    @include flex;

    width: 100%;
  }
  .el-dialog__header {
    margin: 0;
    padding: 0;
    height: 0;
    i {
      color: #908b7f !important;
    }
    .el-dialog__headerbtn {
      right: 4px;
      top: 0;
    }
  }
  .el-dialog__body {
    @include flex(normal);

    padding: 0;
    width: 100%;
    min-height: 570px;
  }
  .wrap-close {
    position: absolute;
    z-index: 9999;
    right: 20px;
    top: 20px;
    display: block;
    font-size: 20px;
    font-family: $f-pb;
    color: #908b7f;
    cursor: pointer;
  }
}
.tryon-confirm-button {
  margin-right: 10px;
  color: $origin !important;
  background: #ffffff !important;
  order: 1;
}
.tryon-cancel-button {
  color: #ffffff !important;
  background-color: $origin;
  order: 2;
  &:hover {
    background: $origin !important;
  }
}
</style>
<style lang="scss" scoped>
.close-tip {
  .title {
    margin-bottom: 40px;
    text-align: center;
    font-size: 20px;
    font-family: $f-pb;
  }
  p {
    text-align: center;
  }
  .btn-box {
    margin: 40px auto 20px;
    width: 400px;

    @include flex($dir: column);
    .el-button {
      margin-left: 0;
      height: 45px;
      &.second {
        margin-top: 15px;
      }
    }
  }
}
.trybox-left {
  min-width: 460px;
  max-width: 460px;
}
.glasses-container {
  height: 100%;
  #imgCon {
    @include prefix(user-select, none);

    position: relative;
    width: 100%;
    min-height: 460px;
    background-size: cover;
    .bgImg {
      display: block;
      width: 100%;
      height: auto;
      transform: scale(1.001);
    }
    #glasses {
      position: absolute;
      z-index: 20;
      left: 0;
      top: 0;
      transition: all 0.3s;
      .shade {
        position: absolute;
        z-index: 20;
        width: 100%;
        height: 100%;
        background-color: transparent;
        cursor: pointer;
      }
      img {
        display: block;
        height: auto;
        transition: all 0.3s;
      }
    }
  }
  .swiper-box {
    position: relative;
    margin: 0;
    padding: 0 36px 26px;
    &.spec {
      padding-right: 0;
      padding-left: 18px;
    }
  }
  .pro-imgs {
    padding-top: 20px;
    .img-item {
      position: relative;
      width: 64px;
      height: 64px;
      .iconfont {
        @include flex(center, center);

        position: absolute;
        z-index: 10;
        right: -7px;
        top: -7px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        font-size: 11px;
        color: #ffffff;
        background-color: #908b7f;
        transition: all 0.3s;
        cursor: pointer;
        &:hover {
          background-color: $origin;
        }
      }
      img {
        display: block;
        width: 100%;
        height: auto;
        max-height: 64px;
        border: 1px solid transparent;
        border-radius: 6px;
        transition: all 0.3s;
        cursor: pointer;
        box-sizing: border-box;
        &:hover {
          border: 1px solid $origin;
        }
      }
    }
    .show-border {
      img {
        border: 1px solid $origin;
      }
    }
  }
  .button-prev {
    position: absolute;
    z-index: 300;
    left: 3px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    i {
      font-size: 22px;
      color: #5a544e;
      transition: all 0.3s;
      &:hover {
        color: $origin;
      }
    }
  }
  .button-next {
    position: absolute;
    z-index: 300;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    i {
      font-size: 22px;
      /* stylelint-disable-next-line declaration-property-value-disallowed-list */
      font-weight: bold;
      color: #080506;
      transition: all 0.3s;
      &:hover {
        color: $origin;
      }
    }
  }
  .swiper-button-disabled {
    i {
      opacity: 0.2;
    }
  }
}
.cropper-box {
  padding: 75px 0 0;
  width: 100%;
  height: 100%;
  background: #aeaeae;
  box-sizing: border-box;
  .reupload {
    display: block;
    margin: 30px auto 0;
    width: 130px;
    height: 32px;
    border: 0;
    background: #aeaeae;
    cursor: pointer;
    p {
      font-family: $f-pr;
      color: #ffffff;
    }
  }
}
.trybox-right {
  padding: 155px 0 180px;
  width: 100%;

  // .upload-session {

  // }
  .cropper-session {
    margin: 45px 0 0;
    .try-online > div {
      margin-bottom: 30px;
      text-align: center;
      font-family: $f-lr;
    }
    .btn-list {
      @include flex;
      .el-button {
        width: 140px;
        height: 50px;
        border-radius: 4px;
        font-size: 16px;
      }
      .cancel-btn {
        border: 1px solid #080506;
        color: $origin;
        background-color: #ffffff !important;
      }
    }
  }
  .try-online {
    margin: 0 auto;
    width: 260px;
    p {
      margin-bottom: 15px;
      text-align: center;
      font-size: 24px;
      font-family: $f-pb;
    }
    div {
      margin-bottom: 42px;
      line-height: 30px;
      font-size: 16px;
      font-family: $f-lr;

      // text-align: center;
    }
  }
  .upload {
    @include flex(center, center);

    margin: 0 auto;
    width: 280px;
    height: 60px;
    border-radius: 8px;
    background-color: $origin;
    box-sizing: border-box;
    p {
      @include flex(center, center);

      font-size: 18px;
      color: #ffffff;
      i {
        margin-right: 10px;
        font-size: 24px;
      }
    }
  }
}
</style>
